export default "__VITE_ASSET__5606ce91__"